<div class="dialog-header">
  <div class="dialog-title">
    <h1>
      {{ id ? ("editUser" | translate) : ("newUser" | translate) }}
    </h1>
  </div>

  <a href="javascript:;" class="dialog-close" (click)="close()"
    ><i class="fal fa-times"></i
  ></a>
</div>

<div class="dialog-content">
  <nz-spin [nzSpinning]="isLoading">
    <form nz-form nzLayout="vertical" [formGroup]="form" (submit)="save()">
      <nz-form-item>
        <nz-form-label nzFor="name" nzRequired>{{
          "name" | translate
        }}</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="name"
            id="name"
            [placeholder]="'name' | translate"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="email" nzRequired>{{
          "email" | translate
        }}</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="email"
            id="email"
            [placeholder]="'email' | translate"
            type="email"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="role" nzRequired>{{
          "role" | translate
        }}</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="role">
            <nz-option
              [nzValue]="UserRole.SystemAdministrator"
              nzLabel="System Administrator"
            ></nz-option>
            <nz-option
              [nzValue]="UserRole.Administrator"
              nzLabel="Administrator"
            ></nz-option>
            <nz-option [nzValue]="UserRole.User" nzLabel="User"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="password" [nzRequired]="!id">
          {{ id ? ("newPassword" | translate) : ("password" | translate) }}
        </nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="password"
            id="password"
            [placeholder]="
              id ? ('newPassword' | translate) : ('password' | translate)
            "
            type="password"
          />
        </nz-form-control>
      </nz-form-item>

      <div class="mt-4">
        <button nz-button nzType="primary" type="submit" [nzLoading]="isSaving">
          {{ id ? ("saveChanges" | translate) : ("add" | translate) }}
        </button>
        <button
          nz-button
          (click)="close()"
          type="button"
          class="ml-2"
          [disabled]="isSaving"
        >
          {{ "cancel" | translate }}
        </button>
      </div>
    </form>
  </nz-spin>
</div>
